import { PlusIcon } from "lucide-react";
import { Button } from "@/components/Button/Button";
import { AppText } from "@/components/Text/AppText";

export const JobsEmptyState = ({
    term,
    location,
}: {
    term: string;
    location: string;
}) => (
    <div className="flex flex-col items-center justify-center py-16">
        <AppText
            variant="subheadings"
            className="mb-2 text-neutral-900"
        >
            {term || location
                ? "No jobs found"
                : "Enter a job title and location to search"}
        </AppText>
        {!term && !location && (
            <AppText
                variant="regular"
                className="text-neutral-700"
            >
                Try searching for roles like &quot;Software Engineer&quot; or
                locations like &quot;New York&quot;
            </AppText>
        )}
    </div>
);

export const UserJobsEmptyState = ({
    showArchived,
    onCreateJob,
}: {
    showArchived: boolean;
    onCreateJob: () => void;
}) => (
    <div className="flex flex-col items-center justify-center py-16">
        <AppText
            variant="subheadings"
            className="mb-2 text-neutral-900"
        >
            No jobs found
        </AppText>

        <AppText
            variant="regular"
            className="mb-4 text-neutral-600"
        >
            {showArchived
                ? "When you archive jobs, they will appear here"
                : "When you create jobs, they will appear here"}
        </AppText>
        {!showArchived && (
            <Button
                color="softIndigo"
                size="small"
                onClick={() => onCreateJob()}
                leftIcon={<PlusIcon size={16} />}
            >
                Create Job
            </Button>
        )}
    </div>
);
